import { isMobile } from "../modules/utilities";

const MODAL_CLOSE_BTN_ID = 'modal-close-btn';

export const GLOBAL_MODAL_ID = 'global-modal';

//const isMobile = window.innerWidth < 768;

export const openModal = (e, modalId) => {
  if (e) {
    e.stopPropagation();
    e.preventDefault();
  }
  const modalEl = document.getElementById(modalId);
  const body = document.body;
  if (modalId) {
    modalEl.style.display = 'block';
    body.style.overflow = 'hidden';
  }
}

export const openModalGlobalConstructor = ({ content, height = '100%', disableModalGlobal = true, uniqueId }) => {
  openModalGlobal(content, height, disableModalGlobal, uniqueId);
}
export const openModalGlobal = (content, height = '100%', disableModalGlobal = true, uniqueId = '') => {
  console.log('openModalGlobal');
  const modalGlobalEl = document.getElementById(GLOBAL_MODAL_ID);
  const body = document.body;
  if (modalGlobalEl) {
    modalGlobalEl.style.display = 'block';
    body.style.overflow = 'hidden';
    const modalContent = modalGlobalEl.querySelector('.modal-content');
    if (content && modalContent) {
      modalContent.style.height = isMobile ? '100%' : height;
      modalContent.appendChild(content);
    }
    modalGlobalEl.removeAttribute('data-unique-id');
    if (uniqueId) {
      modalGlobalEl.dataset.uniqueId = uniqueId;
    }
    if(disableModalGlobal){
      setTimeout(() => {
        document.addEventListener('click', closeModalGlobal);
      }, 0);
    }
  }
}

export const clearContent = () => {
  const globalModalContent = document.querySelector('div.global-modal-wrapper > #modal-content');

  if (globalModalContent && globalModalContent.children) {
    [...globalModalContent.children].forEach((child, i) => {
      if (i !== 0) {
        child.remove();
      }
    })
  }
}

export const closeModalGlobal = () => {
  console.log('closeModalGlobal');
  const modalGlobalEl = document.getElementById(GLOBAL_MODAL_ID);
  let id = GLOBAL_MODAL_ID;
  const body = document.body;
  if (modalGlobalEl) {
    const uniqueId = modalGlobalEl.dataset.uniqueId;
    if (uniqueId) {
      id += `_${uniqueId}`;
    }
  }
  document.dispatchEvent(new CustomEvent("beforeCloseModalEvent", {
    bubbles: true,
    detail: {
      id,
    }
  }));
  if (modalGlobalEl) {
    clearContent();
    modalGlobalEl.style.display = 'none';
    body.style.overflow = 'auto';
    document.removeEventListener('click', closeModalGlobal);
  }
  if (window.parent && window.parent.postMessage) {
    window.parent.postMessage(`close modal with id = ${id}`);
  }

  document.dispatchEvent(new CustomEvent("closeModalEvent", {
    bubbles: true,
    detail: {
      id,
    }
  }));
}

export const closeModal = (e, modalId) => {
  console.log('closeModal123123');
  console.log(e);
  console.log(modalId);
  const modalEl = document.getElementById(modalId);
  const body = document.body;
  if (modalEl) {
    modalEl.style.display = 'none';
    body.style.overflow = 'auto';
  }
  if (window.parent && window.parent.postMessage) {
    window.parent.postMessage(`close modal with id = ${modalId}`);
  }
}

export const hideCloseBtn = () => {
  const modalCloseBtn = document.getElementById(MODAL_CLOSE_BTN_ID);
  if (modalCloseBtn) {
    modalCloseBtn.style.display = 'none';
  }
}
export const showCloseBtn = () => {
  const modalCloseBtn = document.getElementById(MODAL_CLOSE_BTN_ID);
  if (modalCloseBtn) {
    modalCloseBtn.style.display = 'block';
  }
}



// WEBPACK FOOTER //
// ./src/js/components/modal.js